import { UpdateUserInput } from '@okapi/graphql/types.generated';

import { getUnitId } from '../helpers';
import { UserFormValues } from '../UserForm/types';

export const preparePayload = (values: UserFormValues, userId: string, adminUnitId: string): UpdateUserInput => {
  const { firstName, lastName, role, email } = values;

  return {
    assignedRole: {
      role,
      unitId: getUnitId(values, adminUnitId)
    },
    email,
    firstName,
    id: userId,
    lastName
  };
};
